export const ADD_CARD = 'addCard'
export const ADD_PASS = 'addPass'
export const DELETE_CARD = 'deleteCard'
export const DELETE_PASS = 'deletePass'
export const FETCH_START = 'setLoading'
export const PURGE_AUTH = 'logOut'
export const SET_AUTH = 'setAuth'
export const SET_USER = 'setUser'
export const SET_COMPANY = 'setCompany'
export const SET_CARDS = 'setCards'
export const SET_ERROR = 'setError'
export const SET_LOADING = 'setLoading'
export const SET_PASSES = 'setPasses'
export const SET_PROFILE = 'setProfile'
export const SET_REGISTER_FIELDS = 'setRegisterFields'
export const SET_PROFILE_PICTURE = 'setProfilePicture'
export const RESET_STATE = 'resetModuleState'
export const SET_CHANGE_PASSWORD_RESPONSE = 'changePasswordResponse'

export const SET_AGREEMENT_DATA = 'setAgreementData'
export const SET_AGREEMENTS_DATA = 'setAgreementsData'
export const SET_HAS_AGREEMENTS = 'setHasAgreements'



// WEBPACK FOOTER //
// ./src/store/types/mutations.type.js